import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function StorySection() {
  return <section className="py-20 bg-[#0A0E27] relative" data-id="element-268" data-mp="c13a6c9gx80e">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269" data-mp="c1uugqxm7jbd">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-270" data-mp="8117q0vwsak2">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-271" data-mp="14qa5l2dmlhhf">
            Warum ich <span className="text-[#FF5722]" data-id="element-272" data-mp="14nwfl7xsyvgq">CRM Kraft</span>{' '}
            entwickelt habe
          </h2>
          <div className="h-1 w-20 bg-[#FF5722] mx-auto rounded-full" data-id="element-273" data-mp="vpkeud382hak"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-274" data-mp="vrf0xuq8cfg8">
          <div className="space-y-6 text-lg text-[#94A3B8] leading-relaxed" data-id="element-275" data-mp="qq7ubyztpmb5">
            <p data-id="element-276" data-mp="3ggkwonpjr6tb">
              <strong className="text-white" data-id="element-277" data-mp="3ghe3fooi9wbg">
                "Wir automatisieren alles außer den Spaß."
              </strong>
            </p>
            <p data-id="element-278" data-mp="1o7xwfyk1jl2e">
              Ich komme aus zwei Welten: der IT und dem Vertrieb. Diese
              Kombination ist selten – und genau das macht den entscheidenden
              Unterschied.
            </p>
            <p data-id="element-279" data-mp="1f7j8erfozrv7">
              Als Entwickler verstehe ich die technischen Anforderungen an ein
              robustes System. Als Vertriebler kenne ich den täglichen Kampf um
              Leads, die Frustration über manuelle Dateneingabe und den Druck
              der Quartalsziele.
            </p>
            <p data-id="element-280" data-mp="1a8gh09smxk5p">
              Viele CRM-Systeme werden im Elfenbeinturm entwickelt. CRM Kraft
              wurde in der Praxis geschmiedet. Jede Funktion existiert, weil sie
              ein echtes Problem löst, das ich oder mein Team selbst erlebt
              haben.
            </p>

            <div className="pt-6 flex flex-col sm:flex-row gap-4" data-id="element-281" data-mp="mim5bvk1y1n1">
              <Button variant="outline" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-283" data-mp="rg43qs0g0ygs" />} onClick={openCalendlyPopup} data-id="element-282" data-mp="mkfaf6f0odsx">
                Kostenlose Demo buchen
              </Button>
              <Button variant="outline" rightIcon={<ExternalLink className="w-4 h-4" data-id="element-285" data-mp="2oe1n6fu2i30p" />} onClick={() => window.open('https://crm-kraft.de/', '_blank', 'noopener,noreferrer')} data-id="element-284" data-mp="2ofcqyfnijart">
                CRM Kraft entdecken
              </Button>
            </div>
          </div>

          <div className="relative" data-id="element-286" data-mp="384n4po3p7lna">
            <div className="absolute inset-0 bg-gradient-to-r from-[#FF5722]/20 to-[#3B82F6]/20 blur-3xl rounded-full opacity-30" data-id="element-287" data-mp="334ips2ifuyz6"></div>
            <div className="relative bg-[#141B3A] border border-[#1E293B] rounded-2xl p-8 md:p-12" data-id="element-288" data-mp="2y4walnj1v8nq">
              <blockquote className="text-xl md:text-2xl font-medium text-white italic mb-8" data-id="element-289" data-mp="1rqewyznl7gvp">
                "Mein Ziel war kein weiteres kompliziertes Tool, sondern ein
                System, das Vertriebsteams wirklich nutzen wollen, weil es ihnen
                Arbeit abnimmt statt neue zu schaffen."
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-290" data-mp="1hjkkhszs4fi8">
                <div className="w-12 h-12 rounded-full bg-[#FF5722] flex items-center justify-center text-white font-bold" data-id="element-291" data-mp="1mjqidqwn6y8r">
                  JK
                </div>
                <div data-id="element-292" data-mp="1vdbx5a8t4fi6">
                  <div className="font-bold text-white" data-id="element-293" data-mp="1vdv8g83yc5n8">Justus Kraft</div>
                  <div className="text-sm text-[#94A3B8]" data-id="element-294" data-mp="20bwpknhthuw2">
                    Gründer CRM Kraft
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}